import type { EmaProductsReviewAction, EmaProductsReviewState } from './EMAProductsReview.types';

export const createInitialEmaProductsState = (): EmaProductsReviewState => ({
  loading: false,
  products: [],
  selectedProductId: null,
  pdfUrl: '',
  productUrl: '',
  initialCount: 0,
  sessionNewCount: 0,
  mode: 'view',
  dialog: null,
  pendingForm: null
});

export const emaProductsReviewReducer = (
  state: EmaProductsReviewState,
  action: EmaProductsReviewAction
): EmaProductsReviewState => {
  switch (action.type) {
    case 'LOAD_STARTED':
      return { ...state, loading: true };
    case 'LOAD_SUCCEEDED':
      return {
        ...state,
        loading: false,
        products: action.value.products,
        pdfUrl: action.value.pdfUrl,
        productUrl: action.value.productUrl,
        initialCount: action.value.initializeCount
          ? action.value.products.length
          : state.initialCount
      };
    case 'LOAD_FAILED':
      return { ...state, loading: false, products: [] };
    case 'SET_LOADING':
      return { ...state, loading: action.value };
    case 'SELECT_PRODUCT':
      return { ...state, selectedProductId: action.value };
    case 'SET_MODE':
      return { ...state, mode: action.value };
    case 'OPEN_SUBMIT_DIALOG':
      return { ...state, dialog: 'submit', pendingForm: action.value };
    case 'OPEN_DIALOG':
      return { ...state, dialog: action.value };
    case 'CLOSE_DIALOG':
      return { ...state, dialog: null };
    case 'SAVE_SUCCEEDED':
      return {
        ...state,
        loading: false,
        selectedProductId: action.productId,
        sessionNewCount: state.sessionNewCount + (action.wasAdd ? 1 : 0),
        mode: 'view',
        dialog: null,
        pendingForm: null
      };
    default:
      return state;
  }
};
